var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"},attrs:{"id":"app"}},[_c('v-app',[_c('router-view',{on:{"loadExist":_vm.getExistencia}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }